import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';

interface OrderConfirmData {
  purchaseType: string;
  shipmentType: string | null;
  status: string;
  isPastPreOrderFullfillmentDate: boolean | null;
}

/**
 * Order Confirm Button Component
 *
 * @export
 * @class OrderConfirmButtonComponent
 * @extends {Vue}
 */
@Component
export default class OrderConfirmButtonComponent extends Vue {
  @Prop({ type: Object, required: true }) order!: OrderConfirmData;

  @Emit('confirm-order')
  public confirmOrder(): void {}

  get isDeliveryEnabled(): boolean {
    return (
      this.order.status === 'PAYMENT_RECEIVED' ||
      (this.order.status === 'ORDER_CONFIRMED' &&
        this.order.isPastPreOrderFullfillmentDate === true) ||
      (this.order.status === 'ORDER_CONFIRMED' &&
        this.order.isPastPreOrderFullfillmentDate === null) ||
      this.order.status === 'ON_PICKUP'
    );
  }

  get isWalkInEnabled(): boolean {
    return this.order.status === 'PAYMENT_RECEIVED';
  }

  get isConfirmEnabled(): boolean {
    return this.order.status === 'PAYMENT_RECEIVED';
  }

  get hasDeliveryToConfirm(): boolean {
    return (
      this.order.shipmentType && this.order.purchaseType !== 'SUBSCRIPTION'
    );
  }
}
